import z from "zod";

const zFloorSchema = z
  .number()
  .int()
  .positive()
  .max(2 ** 9)
  .brand("Floor");
type FloorSchema = z.infer<typeof zFloorSchema>;

export { zFloorSchema };
export type { FloorSchema as Floor, FloorSchema };
